import { render, staticRenderFns } from "./editarApoyoSolicitante.vue?vue&type=template&id=68b0cef6"
import script from "./editarApoyoSolicitante.vue?vue&type=script&lang=js"
export * from "./editarApoyoSolicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports